import { ReactComponent as ArrowLeftIcon } from './arrow-left-icon.svg';
import { ReactComponent as EyeClosedIcon } from './eye-closed-icon.svg';
import { ReactComponent as EyeIcon } from './eye-open-icon.svg';
import { ReactComponent as TickIcon } from './tick-icon.svg';
import { ReactComponent as CloseIcon } from './close-icon.svg';
import { ReactComponent as AlertCross } from './alert-cross.svg';
import { ReactComponent as CloseIconGray } from './close-gray.svg';
import { ReactComponent as PasswordSuccessTick } from './password-success-tick.svg';
import { ReactComponent as IndividualIcon } from './individual-icon.svg';
import { ReactComponent as FamilyIcon } from './family-icon.svg';
import { ReactComponent as FamilyIconPlus } from './family-icon-plus.svg';
import { ReactComponent as PricingArrow } from './arrow-pricing.svg';
import { ReactComponent as CreditCardIcon } from './credit-card-icon.svg';
import { ReactComponent as BankTransferIcon } from './bank-tranfer-icon.svg';
import { ReactComponent as InfoIcon } from './info-icon.svg';
import { ReactComponent as PaymentSuccessIcon } from './payment-success-icon.svg';
import { ReactComponent as HeaderLogo } from './header-logo.svg';
import { ReactComponent as PaymentFailedIcon } from './payment-failed.svg';
import { ReactComponent as FavoritesIcon } from './favorite-icon.svg';
import { ReactComponent as PhotosIcon } from './photos-icon.svg';
import { ReactComponent as PeopleIcon } from './people-icon.svg';
import { ReactComponent as MemoriesIcon } from './memories-icon.svg';
import { ReactComponent as FamilyTreeIcon } from './family-tree-icon.svg';
import { ReactComponent as RecipesIcon } from './recipie-icon.svg';
import { ReactComponent as SharingIcon } from './share-icon.svg';
import { ReactComponent as StorageIcon } from './storage-icon.svg';
import { ReactComponent as TrashIcon } from './trash-icon.svg';
import { ReactComponent as CameraIcon } from './upload-image-icon.svg';
import { ReactComponent as UploadModalIcon } from './upload-modal-icon.svg';
import { ReactComponent as ProfileEditIcon } from './profile-edit-icon.svg';
import { ReactComponent as LogoutIcon } from './logout-icon.svg';
import { ReactComponent as PersonIcon } from './person-icon.svg';
import { ReactComponent as DashboardIcon } from './dashboard-icon.svg';
import { ReactComponent as SettingsIcon } from './settings-icon.svg';
import { ReactComponent as PencilIcon } from './pencil-icon.svg';
import { ReactComponent as TakePicIcon } from './take-picture-icon.svg';
import { ReactComponent as RemoveIcon } from './trash-green-icon.svg';
import { ReactComponent as UploadIcon } from './upload-icon.svg';
import { ReactComponent as ModalUploadIcon } from './modal-upload-icon.svg';
import { ReactComponent as AddRoundIcon } from './add.svg';
import { ReactComponent as SubscriptionIcon } from './subscription-icon.svg';
import { ReactComponent as PaymentsIcon } from './payments-icon.svg';
import { ReactComponent as SecurityPrivacy } from './security-privacy.svg';
import { ReactComponent as Notification } from './notification-icon.svg';
import { ReactComponent as Help } from './help.svg';
import { ReactComponent as Delete } from './delete-icon.svg';
import { ReactComponent as Visa } from './visa.svg';
import { ReactComponent as Master } from './master.svg';
import { ReactComponent as AlertCheck } from './alert-check.svg';
import { ReactComponent as AlertError } from './alert-error.svg';
import { ReactComponent as AlertInfo } from './alert-info.svg';
import { ReactComponent as AlertWarning } from './alert-warning.svg';
import { ReactComponent as CloseBtn } from './close-btn.svg';
import { ReactComponent as SeeMore } from './see-more.svg';
import { ReactComponent as ChangeSubscription } from './change-sub-icon.svg';
import { ReactComponent as CancelSubscription } from './cancel-sub-icon.svg';
import { ReactComponent as AmpleIcon } from './ample-icon.svg';
import { ReactComponent as AnywhereAccess } from './anywhere-access-icon.svg';
import { ReactComponent as Privacy } from './privacy-icon.svg';
import { ReactComponent as Seamless } from './seamless-collab.svg';
import { ReactComponent as Backup } from './automatic-backup.svg';
import { ReactComponent as BackIcon } from './back-icon.svg';
import { ReactComponent as ShareIcon } from './share-icon.svg';
import { ReactComponent as LinkIcon } from './link-icon.svg';
import { ReactComponent as Expand } from './expand.svg';
import { ReactComponent as StarIcon } from './star-icon.svg';
import { ReactComponent as DownloadIcon } from './download-icon.svg';
import { ReactComponent as MoreIcon } from './more-icon.svg';
import { ReactComponent as Share } from './share.svg';
import { ReactComponent as ZoomIn } from './zoomIn.svg';
import { ReactComponent as Info } from './info.svg';
import { ReactComponent as Favorite } from './favorite.svg';
import { ReactComponent as DeleteIcon } from './delete.svg';
import { ReactComponent as Send } from './send.svg';
import { ReactComponent as DeleteConfirm } from './delete-confirm.svg';
import { ReactComponent as PlusRounded } from './plus-rounded.svg';
import { ReactComponent as Folder } from './folder-icon.svg';
import { ReactComponent as ThreeDots } from './three-dots.svg';
import { ReactComponent as ListIcon } from './list-icon.svg';
import { ReactComponent as GridIcon } from './grid-icon.svg';
import { ReactComponent as Search } from './search-icon.svg';
import { ReactComponent as Bank } from './bank.svg';
import { ReactComponent as Card } from './card.svg';
import { ReactComponent as SubscriptionSelected } from './subscription-selected.svg';
import { ReactComponent as PaymentSelected } from './payment-selected.svg';
import { ReactComponent as SecuritySelected } from './security-selected.svg';
import { ReactComponent as NotificationSelected } from './notification-selected.svg';
import { ReactComponent as HelpSelected } from './help-selected.svg';
import { ReactComponent as FavoriteIcons } from './favorite-icons.svg';
import { ReactComponent as MoveTo } from './moveTo.svg';
import { ReactComponent as LikeIcons } from './like-icons.svg';
import { ReactComponent as CommentIcons } from './comment-icons.svg';
import { ReactComponent as YellowFav } from './yellow-fav.svg';
import { ReactComponent as GreenTick } from './green-tick-icon.svg';
import { ReactComponent as LockClosedIcon } from './lock-closed-icon.svg';
import { ReactComponent as LockOpen } from './lock-open.svg';
import { ReactComponent as Diary } from './diary.svg';
import { ReactComponent as ThreeDot } from './three-dot.svg';
import { ReactComponent as Owner } from './owner.svg';
import { ReactComponent as Locations } from './location.svg';
import { ReactComponent as Things } from './things.svg';
import { ReactComponent as ZoomOut } from './zoom-out.svg';
import { ReactComponent as TickIcons } from './tickIcon.svg';
import { ReactComponent as Shares } from './shares.svg';
import { ReactComponent as MoveTos } from './move-to.svg';
import { ReactComponent as DiaryIcon } from './diary-icon.svg';
import { ReactComponent as PeopleWhite } from './people-white.svg';
import { ReactComponent as PhotoWhite } from './photo-white.svg';
import { ReactComponent as RecipieWhite } from './recipie-white.svg';
import { ReactComponent as TreeWhite } from './tree-white.svg';
import { ReactComponent as ShareWhite } from './share-white.svg';
import { ReactComponent as TrashWhite } from './trash-white.svg';
import { ReactComponent as MemoryWhite } from './memory-white.svg';
import { ReactComponent as FavoriteEmpty } from './favorite-empty.svg';
import { ReactComponent as MemoriesEmpty } from './memories-empty.svg';
import { ReactComponent as PeopleEmpty } from './people-empty.svg';
import { ReactComponent as RecipieEmpty } from './recipie-empty.svg';
import { ReactComponent as ShareEmpty } from './share-empty.svg';
import { ReactComponent as StorageEmpty } from './storage-empty.svg';
import { ReactComponent as TrashEmpty } from './trash-empty.svg';
import { ReactComponent as TreeEmpty } from './tree-empty.svg';
import { ReactComponent as StorageWhite } from './storage-white.svg';
import { ReactComponent as FilterEmpty } from './filter-empty.svg';
import { ReactComponent as CancellationSmile } from './cancelation-smile.svg';

export const SVGAssets = {
  AlertCheck,
  AlertError,
  AlertInfo,
  AlertWarning,
  ArrowLeftIcon,
  EyeClosedIcon,
  EyeIcon,
  TickIcon,
  CloseIcon,
  AlertCross,
  CloseIconGray,
  PasswordSuccessTick,
  IndividualIcon,
  FamilyIcon,
  FamilyIconPlus,
  PricingArrow,
  CreditCardIcon,
  BankTransferIcon,
  InfoIcon,
  PaymentSuccessIcon,
  HeaderLogo,
  PaymentFailedIcon,
  FavoritesIcon,
  PhotosIcon,
  PeopleIcon,
  MemoriesIcon,
  FamilyTreeIcon,
  RecipesIcon,
  SharingIcon,
  StorageIcon,
  TrashIcon,
  CameraIcon,
  UploadModalIcon,
  ProfileEditIcon,
  PersonIcon,
  LogoutIcon,
  DashboardIcon,
  SettingsIcon,
  PencilIcon,
  TakePicIcon,
  RemoveIcon,
  UploadIcon,
  ModalUploadIcon,
  AddRoundIcon,
  SubscriptionIcon,
  PaymentsIcon,
  SecurityPrivacy,
  Notification,
  Help,
  Delete,
  Master,
  Visa,
  CloseBtn,
  SeeMore,
  ChangeSubscription,
  CancelSubscription,
  AmpleIcon,
  AnywhereAccess,
  Privacy,
  Seamless,
  Backup,
  BackIcon,
  ShareIcon,
  LinkIcon,
  StarIcon,
  DownloadIcon,
  MoreIcon,
  Expand,
  Share,
  ZoomIn,
  Info,
  Favorite,
  DeleteIcon,
  Send,
  DeleteConfirm,
  PlusRounded,
  Folder,
  ThreeDots,
  ListIcon,
  GridIcon,
  Search,
  Bank,
  Card,
  FavoriteIcons,
  MoveTo,
  LikeIcons,
  CommentIcons,
  YellowFav,
  LockClosedIcon,
  LockOpen,
  GreenTick,
  Diary,
  SubscriptionSelected,
  PaymentSelected,
  SecuritySelected,
  NotificationSelected,
  HelpSelected,
  ThreeDot,
  Owner,
  Locations,
  Things,
  ZoomOut,
  TickIcons,
  Shares,
  MoveTos,
  DiaryIcon,
  PeopleWhite,
  PhotoWhite,
  RecipieWhite,
  TreeWhite,
  ShareWhite,
  TrashWhite,
  StorageEmpty,
  ShareEmpty,
  RecipieEmpty,
  PeopleEmpty,
  MemoriesEmpty,
  FavoriteEmpty,
  TreeEmpty,
  TrashEmpty,
  MemoryWhite,
  StorageWhite,
  FilterEmpty,
  CancellationSmile
};
